/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import CustomizePage from 'pages/dashboard/embeds/management/customize/customize';



/* ========== ~~~~~~~~~~ EMBED CUSTOMIZE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const numberOfContents = Object.keys(embedsState.embedManagementState.contentStatus['contents']).length;
   return ({
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
        content: embedsState.embedManagementState.contentStatus['contents'],
        numberOfContents,
        noLiveContents: embedsState.embedManagementState.contentStatus.noLiveContents,
        embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
        isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
        embedsState
    });
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(CustomizePage);
